import React, { useEffect } from "react";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import { AuthContext } from "./AuthProvider";

export const Callback = () => {
    var auth = React.useContext(AuthContext);

    useEffect(() => {
        const signInRedirect = async () => {
            var redirectUrl = await auth.signinRedirectCallback();            
            window.location.replace(redirectUrl);
        };

        signInRedirect().catch(console.error);
    }, []);

    return <AbpnSpinner />;
}